import { Component, inject, OnInit, signal } from '@angular/core';
import { BroadcastService } from '@services/broadcast-service';
import { ConnectionService } from '@services/connection-service';
import { EventLoggerService } from '@services/event-logger-service';
import { LoadingModule } from '@components/loading';
import { CsIconModule } from '@components/icon';
import { UserService } from "@services/user";
import { ApiClientConstant } from "@cureskin/api-client";
import { AppConfig } from '../../app.config';

@Component({
  selector: 'doctor-list',
  templateUrl: './doctor-list.html',
  imports: [LoadingModule, CsIconModule],
})
export class DoctorListComponent implements OnInit {
  private readonly broadcast = inject(BroadcastService);
  private readonly eventLogger = inject(EventLoggerService);
  protected readonly conn = inject(ConnectionService);
  private readonly userService = inject(UserService);
  private readonly appConfig = inject(AppConfig);

  readonly doctors = signal<Table.User[]>([]);
  readonly loading = signal<boolean>(true);

  async ngOnInit(): Promise<void> {
    await this.findDoctorsLocal();
    this.eventLogger.cleverTapEvent('pageOpen', JSON.stringify({ pageName: 'doctors-list' }));
  }

  async findDoctorsLocal(): Promise<void> {
    this.loading.set(true);
    try {
      const doctors = await this.conn.findDoctors();
      this.doctors.set(
        doctors.filter((each) =>
          each.get('doctorDisplayImage') && each.get('doctorQualification') === this.appConfig.Shared.Doctor.DERMATOLOGIST)
      );
    } finally {
      this.loading.set(false);
    }
  }

  back(): void {
    this.broadcast.broadcast('NAVIGATION_BACK');
  }

  viewDoctor(doctor: Table.User): void {
    this.conn.navigateToURL(`/doctor/${doctor.id}`);
  }

  handleViewDoctor(doctor: Table.User): void {
    this.viewDoctor(doctor);
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'view-doctor-details' }));
  }

  stopPropagation(event: Event): void {
    event.stopPropagation();
  }

  get userLanguagePreference(): string {
    return this.userService.getUserLanguagePreference();
  }

  protected readonly ApiClientConstant = ApiClientConstant;
}
